import { toast } from 'react-toastify';

const utils = {
    validateEmail: (email) => {
        const errors = [];

        if (email.length > 0) {
            const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
            if (!email.match(isValidEmail)) {
                errors.push("Invalid email address")
            }
        }
        return errors;
    },
    validatePassword: (password) => {
        const hints = [];
    
        if (password.length < 8) {
            hints.push("at least 8 characters long");
        }
        if (!/[A-Z]/.test(password)) {
            hints.push("at least one uppercase letter");
        }
        if (!/[a-z]/.test(password)) {
            hints.push("at least one lowercase letter");
        }
        if (!/[0-9]/.test(password)) {
            hints.push("at least one number.");
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
            hints.push("at least one special character");
        }
        return hints;
    },
    toTitleCase: (str) => {
        return str
            .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
            // .toLowerCase() // Convert the entire string to lowercase first
            .split(' ')    // Split the string into words
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(' ');    // Join the words back into a single string
    },
    checkMobile: () => {
        const ua = navigator.userAgent;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    },
    toastVerify: (message) => {
      toast.dismiss();
      setTimeout(() => {
        toast.warning(message, {
          autoClose: false,
        });
      }, 500);
      setTimeout(() => {
        toast.success('Please verify your email using the link in the email', {
          autoClose: false,
        });
      }, 3500);
      setTimeout(() => {
        toast.info('Or, click the "Resend Verify" button to recieve another email', {
          autoClose: false,
        });
      }, 7000);
      setTimeout(() => {
        toast.success('If you have already verified, please logout and login again', {
          autoClose: false,
        });
      }, 10500);
    },
    scaleMobile: () => {
        if (utils.checkMobile()) {
            // option 1
            // const viewport = document.querySelector('meta[name="viewport"]');
            // if (viewport) {
            //     viewport.content = 'width=device-width, initial-scale=0.85, maximum-scale=0.85, user-scalable=no';
            // } else {
            //     const meta = document.createElement('meta');
            //     meta.name = 'viewport';
            //     meta.content = 'width=device-width, initial-scale=0.85, maximum-scale=0.85, user-scalable=no';
            //     document.head.appendChild(meta);
            // }
            // console.log("hello")
            // const meta = document.createElement('meta');
            // meta.name = 'viewport';
            // meta.content = 'width=device-width, initial-scale=0.85, maximum-scale=0.85, user-scalable=no';
            // document.head.appendChild(meta);

            // option 2
            // document.documentElement.classList.add('mobile-scale');
            // const style = document.createElement('style');
            // style.textContent = `
            // .mobile-scale {
            //     transform: scale(0.85);
            //     transform-origin: top left;
            //     width: 117.65%; /* 100% ÷ 0.85 */
            //     height: 117.65%;
            //     position: absolute;
            // }
            // `;
            // document.head.appendChild(style);

            // option 3
            // const style = document.createElement('style');
            // style.textContent = `
            //     html, body {
            //         zoom: 0.85; /* Works in some browsers */
            //         -moz-transform: scale(0.85); /* Firefox */
            //         -moz-transform-origin: 0 0;
            //         -o-transform: scale(0.85); /* Opera */
            //         -o-transform-origin: 0 0;
            //         -webkit-transform: scale(0.85); /* Safari and Chrome */
            //         -webkit-transform-origin: 0 0;
            //         transform: scale(0.85);
            //         transform-origin: 0 0;
            //     }
            // `;
            // document.head.appendChild(style);
        }
    },
};

export default utils;

